import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const JOB_BASE = process.env.REACT_APP_JOB_CREATE_BASE || "";

export const getJobDetail = createAsyncThunk(
  "getJobDetail",
  async (pageData: any) => {
    try {
      const { data } = await axios.get(
        `${GATEWAY_BASE + JOB_BASE}/api/v1/jobs/details/${pageData.jobId}`
      );

      return data;
    } catch (error: any) {
      // Throw the entire error object to be caught in the rejected case
      throw error.response?.data.statusCode;
    }
  }
);

const getJobDetailSlice = createSlice({
  name: "getJobDetail",
  initialState: {
    loading: false,
    jobData: null as any,
    error: false,
    errorData: null as any,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getJobDetail.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getJobDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.jobData = action.payload;
    });
    builder.addCase(getJobDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorData = action.error;
    });
  },
});

export default getJobDetailSlice.reducer;
